import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './AuditSection.module.css';
import TableFull from '../../ReusableComponents/Table/TableFull';
import AuditStatusTableRow from './AuditStatusTableRow/AuditStatusTableRow';
import TextButton from '../../ReusableComponents/TextButton';
import { auditDataShape } from './_common_/propTypes';

export default function PurchaseOrderDetailAuditSection({ audits }) {
  const [openAuditDetails, setOpenAuditDetails] = useState(false);

  const handleAuditDetailsButtonClick = () => {
    setOpenAuditDetails(!openAuditDetails);
  };

  const hasAudits = audits && audits.length > 0;

  return (
    <div>
      <h4 className={styles.sectionHeader}>PO Compliance Audit Info</h4>
      {hasAudits ? (
        <TextButton
          onClick={handleAuditDetailsButtonClick}
          style={{ fontWeight: 500, color: '#0000EE' }}
        >
          {openAuditDetails
            ? 'click here to hide audit details'
            : 'click here to show audit details'}
        </TextButton>
      ) : (
        <p>No audit data available</p>
      )}
      {openAuditDetails && hasAudits ? (
        <TableFull
          headerCells={[
            {
              value: 'box_number',
              label: 'Box #',
              width: '50px',
            },
            {
              value: 'lpn',
              label: 'LPN #',
              width: '50px',
            },
            {
              value: 'status',
              label: 'Status',
              width: '40px',
            },
            { value: 'timestamp', label: 'Timestamp' },
            {
              value: 'details',
              label: 'Details',
            },
          ]}
          count={audits.length}
          customMinHeight="20vh"
        >
          {audits.map((auditData) => (
            <AuditStatusTableRow
              key={`${auditData.box_number}-${auditData.status}-${auditData.timestamp}`}
              auditData={auditData}
            />
          ))}
        </TableFull>
      ) : null}
    </div>
  );
}

PurchaseOrderDetailAuditSection.propTypes = {
  audits: PropTypes.arrayOf(auditDataShape).isRequired,
};
